import { render, staticRenderFns } from "./RefundItem.vue?vue&type=template&id=5b374ead&scoped=true&"
import script from "./RefundItem.vue?vue&type=script&lang=js&"
export * from "./RefundItem.vue?vue&type=script&lang=js&"
import style0 from "./RefundItem.vue?vue&type=style&index=0&id=5b374ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b374ead",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
